import { EquipmentStatus } from "@validereinc/domain";
import { toTitleCaseString } from "@validereinc/utilities";
import { convertMapToOpts } from "../shared/index.ts";

export const EquipmentStatusOptions = convertMapToOpts(
  EquipmentStatus,
  ([_, value]) => toTitleCaseString(value)
);
